export default {
  methods: {
    getOrderedKpi(item) {
      if (!item || !item.SurveyWave || !item.SurveyWave[0].PropertyValue)
        return;

      let kpi = {
        KpiCode: item ? item.KpiCode : "Missing",
        KpiName: item ? item.KpiName : "Missing",
        Tagged: true,
        Competition: []
      };

      let i1 = _.find(item.SurveyWave, ['PropertyValue', 'BMW M']);
      if (i1)
        kpi.Competition.push({ Brand: i1.PropertyValue, Points: i1.Result });

      let i2 = _.find(item.SurveyWave, ['PropertyValue', 'Competitors']);
      if (i2)
        kpi.Competition.push({ Brand: i2.PropertyValue, Points: i2.Result });

      let i3 = _.find(item.SurveyWave, ['PropertyValue', 'AMG']);
      if (i3)
        kpi.Competition.push({ Brand: i3.PropertyValue, Points: i3.Result });

      let i4 = _.find(item.SurveyWave, ['PropertyValue', 'AUDI']);
      if (i4)
        kpi.Competition.push({ Brand: i4.PropertyValue, Points: i4.Result });

      let i5 = _.find(item.SurveyWave, ['PropertyValue', 'Porsche']);
      if (i5)
        kpi.Competition.push({ Brand: i5.PropertyValue, Points: i5.Result });

      return kpi;
    },
  }
}
